/**
 * Normalize a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quaternion to normalize
 * @returns {quat} out
 * @function
 */
module.exports = require('gl-vec4/normalize')



//////////////////
// WEBPACK FOOTER
// ./~/gl-quat/normalize.js
// module id = 176
// module chunks = 0